import React,{useState, useEffect}  from "react";
import { fetchUser } from '../../utils/fetchUser';
import { getRegistroRetiros } from "../../services/RegistroRecolectores";
import { getRegistroEntregas } from "../../services/RegistroEntregas";
import { getEstadisticaPlanesPartner } from "../../services/Reportes";

import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import HeaderStatsPartner from "../../components/Headers/HeaderStatsPartner.js";

const DashboardNPartners = () =>{
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('InicioAnno')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial

  const [equiposT, setEquiposT] = useState(0); // Total Equipos Solicitados
  const [criticosT, setCriticosT] = useState(0); // Total Equipos Criticos Totales
  const [implementaT, setImplementaT] = useState(0); // Total Equipos Implementados Totales

  const userInfo = fetchUser();

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const firstDayYear = new Date(today.getFullYear(), 0, 1);
    if(Como === 'InicioAnno') return firstDayYear;
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

    useEffect(()=>{
      const fetchData = async () => {
          console.log('Fechas seleccionadas:', selectedDate, selectedDateEnd);
          const soliciData = await getEstadisticaPlanesPartner(selectedDate.toISOString(),selectedDateEnd.toISOString(),userInfo.usuario);
          if (soliciData){

            setEquiposT(soliciData);
          }


          const dataR = await getRegistroRetiros(selectedDate.toISOString(),selectedDateEnd.toISOString(),userInfo.usuario);
          if (dataR){
            const sumaRetiros = dataR.reduce((accumulator, { cantidad }) => {
              return accumulator + (cantidad || 0); // Asegura que no sume undefined o null
            }, 0);
            setImplementaT(sumaRetiros);
          }

          const dataE = await getRegistroEntregas(selectedDate.toISOString(),selectedDateEnd.toISOString(),userInfo.usuario);
          if (dataE){
            const sumaEntregas = dataE.reduce((accumulator, { cantidad }) => {
              return accumulator + (cantidad || 0); // Asegura que no sume undefined o null
            }, 0);
            setCriticosT(sumaEntregas);
          }
      };
      fetchData();
    },[selectedDate,selectedDateEnd]); 


  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  return (
    <>

    <div className="bg-white dark:bg-secondary-dark-bg p-4 max-w-4xl mx-auto rounded-2xl shadow-md mt-6">
      <div className="flex flex-col md:flex-row items-center justify-center gap-4">                <div>
                  <SeleccionaFecha
                    selectedDate={selectedDate}
                    handleDateChange={handleDateChange}
                  />
                </div>
                <div>
                  <SeleccionaFecha
                    selectedDate={selectedDateEnd}
                    handleDateChange={handleDateChangeEnd}
                  />
                </div>            
            </div>

      <HeaderStatsPartner 
        equiposT={equiposT}
        criticosT={criticosT}
        implementaT={implementaT}
      />
      </div>
    </>
  );
}

export default DashboardNPartners;